import { render, staticRenderFns } from "./Diploma.vue?vue&type=template&id=bd6b097c&"
import script from "./Diploma.vue?vue&type=script&lang=js&"
export * from "./Diploma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports